import { sleep } from './common.utils';

/**
 * Attempts to scroll to an element with the given id multiple times
 * in given intervals until it succeeds or reaches max amount of retries
 */
export const scrollToElementWithRetries = async (
  elementId: string,
  options = {
    retries: 4,
    retryIntervalMs: 500,
  }
) => {
  if (attemptToScrollToElement(elementId)) return;

  for (let i = 0; i < options.retries; i++) {
    // Wait for an interval
    await sleep(options.retryIntervalMs);

    // If the element was found, escape
    if (attemptToScrollToElement(elementId)) return;
  }
};

/** Attempts to get an element and scroll to it. Returns true if element is found. */
export const attemptToScrollToElement = (elementId: string): boolean => {
  const htmlElement = document.getElementById(elementId);

  htmlElement?.scrollIntoView(true);

  return !!htmlElement;
};
